import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";

const config = {
    actualLiquidDataRange: {
        // field
        label: "Допустимое время отсутствия данных ДУТ для открытия топливного лимита (в минутах)",
        inputProps: { name: "actualLiquidDataRange" },
        required: true,
        validators: [requiredField],
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
